import { useEffect, useRef, useState } from 'react';

const WORDS = [
  'React', 'Vue', 'Python', 'Django', 'REST APIs', 'Odoo', 'WordPress',
  'frontend', 'backend', 'integration', 'deploy', 'TypeScript', 'CSS',
  'modules', 'WooCommerce', 'plugins', 'themes', 'full-stack', 'solo',
  'fast', 'direct', 'build', 'ship', 'debug', 'migrate', 'automate',
  'connect', 'scale', 'craft', 'launch',
];

const CARDS = [
  { title: 'Frontend', body: 'React · Vue · CSS · TypeScript' },
  { title: 'Backend', body: 'Python · Django · REST APIs' },
  { title: 'Odoo', body: 'Integration · Custom modules · Deploy' },
  { title: 'WordPress', body: 'Themes · Plugins · WooCommerce' },
  {
    title: 'revesaveur.com',
    body: null,
    link: 'https://revesaveur.com',
  },
  {
    title: 'Just me.',
    body: 'Fast · direct · no account managers',
    email: 'contact@technisys.ch',
  },
];

let wordIdCounter = 0;
let cardIdCounter = 0;

export default function EasterEggOverlay() {
  const [trailWords, setTrailWords] = useState([]);
  const [cards, setCards] = useState([]);

  const lastPosRef = useRef(null);
  const lastWordRef = useRef(null);
  const cardIndexRef = useRef(0);

  useEffect(() => {
    function pickWord() {
      const pool = WORDS.filter((w) => w !== lastWordRef.current);
      const word = pool[Math.floor(Math.random() * pool.length)];
      lastWordRef.current = word;
      return word;
    }

    function handleMouseMove(e) {
      const { clientX: x, clientY: y } = e;
      if (lastPosRef.current) {
        const dx = x - lastPosRef.current.x;
        const dy = y - lastPosRef.current.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 60) return;
      }
      lastPosRef.current = { x, y };

      const id = ++wordIdCounter;
      const word = pickWord();
      setTrailWords((prev) => [...prev, { id, word, x, y }]);
      setTimeout(() => {
        setTrailWords((prev) => prev.filter((w) => w.id !== id));
      }, 1500);
    }

    function handleClick(e) {
      if (e.target.closest('a')) return;
      const { clientX: x, clientY: y } = e;
      const rot = (Math.random() * 6 - 3).toFixed(2) + 'deg';
      const index = cardIndexRef.current;
      const card = CARDS[index];
      cardIndexRef.current = (index + 1) % CARDS.length;

      const id = ++cardIdCounter;
      setCards((prev) => [...prev, { id, card, x, y, rot, index }]);
      setTimeout(() => {
        setCards((prev) => prev.filter((c) => c.id !== id));
      }, 4000);
    }

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 100,
      }}
    >
      {trailWords.map(({ id, word, x, y }) => (
        <span
          key={id}
          style={{
            position: 'absolute',
            left: x,
            top: y,
            transform: 'translate(-50%, -50%)',
            fontSize: '0.8rem',
            fontFamily: 'monospace',
            color: 'rgb(163,59,40)',
            animation: 'trailFade 1.5s ease forwards',
            whiteSpace: 'nowrap',
            userSelect: 'none',
          }}
        >
          {word}
        </span>
      ))}

      {cards.map(({ id, card, x, y, rot, index }) => (
        <div
          key={id}
          style={{
            position: 'absolute',
            left: x,
            top: y,
            transform: 'translate(-50%, -50%)',
            '--rot': rot,
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            padding: '10px 14px',
            minWidth: '160px',
            maxWidth: '220px',
            animation: 'cardDrift 4s ease forwards',
            userSelect: 'none',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              marginBottom: '4px',
            }}
          >
            <strong style={{ color: 'rgb(163,59,40)', fontSize: '0.95rem' }}>
              {card.title}
            </strong>
            <span style={{ fontSize: '0.65rem', color: '#aaa' }}>
              {index + 1} / {CARDS.length}
            </span>
          </div>
          {card.link ? (
            <a
              href={card.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                pointerEvents: 'auto',
                fontSize: '0.8rem',
                color: 'rgb(163,59,40)',
                fontFamily: 'monospace',
              }}
            >
              → see it live ↗
            </a>
          ) : (
            <p
              style={{
                margin: 0,
                fontSize: '0.8rem',
                fontFamily: 'monospace',
                color: '#333',
              }}
            >
              {card.body}
              {card.email && (
                <>
                  <br />
                  <span style={{ color: 'rgb(163,59,40)' }}>{card.email}</span>
                </>
              )}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
